import { ReactNode } from "react";

import { BuddyDetailsProvider } from "../providers/buddy-details";
import { UserDailyMissionProvider } from "../providers/user-daily-mission";
import { UserLevelProvider } from "../providers/user-level";

export const CombinedProvider = ({ children }: { children: ReactNode }) => {
	return (
		<UserLevelProvider>
			<BuddyDetailsProvider>
				<UserDailyMissionProvider>{children}</UserDailyMissionProvider>
			</BuddyDetailsProvider>
		</UserLevelProvider>
	);
};
